import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { AddRequestForm, RequestDetails, RequestList } from 'support/components';
import { supportRequestListDefaultPayload } from 'support/constants';

import { useAuthUser } from 'authOld/hooks';
import { PageLayout } from 'coreOld/components';

import { filtersConfig } from './configs';

const RequestListPage = () => {
  const [openModal, setOpenModal] = useState(false);

  const { t } = useTranslation();

  const { user } = useAuthUser();

  return (
    <PageLayout title={t('labelSupportRequests')}>
      <RequestList
        filtersConfig={filtersConfig()}
        onAdd={() => setOpenModal(true)}
        initialFilters={supportRequestListDefaultPayload(user).filters}
      />

      <AddRequestForm isOpen={openModal} onClose={() => setOpenModal(false)} />

      <RequestDetails />
    </PageLayout>
  );
};

export default RequestListPage;
